import type { CreateOfferCargoFormSchemaType } from "@/pages/shipper-cargo-create/model/validation";
import { PACKING_STYLES_LIST } from "@/shared/constants/offer-cargo";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { BaseNumberField } from "@/shared/ui/base-number-field";
import { BaseSelect } from "@/shared/ui/base-select";
import { BaseTextField } from "@/shared/ui/base-text-field";
import { AccordionDetails, Box, FormControl, MenuItem } from "@mui/material";
import { type Control, Controller } from "react-hook-form";

export const CargoForm = ({
  isEasyForm,
  control,
}: {
  isEasyForm: boolean;
  control: Control<CreateOfferCargoFormSchemaType>;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>荷物情報</BaseAccordionSummary>
      <AccordionDetails>
        {!isEasyForm && (
          <BaseFormLabel label="品名" sx={{ maxWidth: "376px" }}>
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState }) => (
                <BaseTextField
                  {...field}
                  size="small"
                  fullWidth
                  error={!!fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </BaseFormLabel>
        )}
        <BaseFormLabel
          label="荷姿"
          sx={{ mt: { xs: 2, sm: 3 }, maxWidth: "376px" }}
          isRequired
        >
          <Controller
            name="packingStyle"
            control={control}
            render={({ field, fieldState }) => (
              <FormControl fullWidth error={fieldState.invalid} size="small">
                <BaseSelect
                  {...field}
                  value={field.value}
                  type="string"
                  sx={{ width: 192 }}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                >
                  {PACKING_STYLES_LIST.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </BaseSelect>
              </FormControl>
            )}
          />
        </BaseFormLabel>
        {!isEasyForm && (
          <Box
            display="flex"
            flexWrap={{ xs: "wrap", sm: "nowrap" }}
            mt={{ xs: 2, sm: 3 }}
            gap={{ xs: 2, sm: 3 }}
          >
            <BaseFormLabel label="数量">
              <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
                <Controller
                  name="count"
                  control={control}
                  render={({ field, fieldState }) => (
                    <BaseNumberField
                      {...field}
                      size="small"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                      sx={{ width: { xs: "100px", sm: "auto" } }}
                    />
                  )}
                />
              </Box>
            </BaseFormLabel>
            <BaseFormLabel label="総重量">
              <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
                <Controller
                  name="weight"
                  control={control}
                  render={({ field, fieldState }) => (
                    <BaseNumberField
                      {...field}
                      size="small"
                      unit="t"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                      sx={{ width: { xs: "100px", sm: "auto" } }}
                    />
                  )}
                />
              </Box>
            </BaseFormLabel>

            {/* SPだけここで改行する */}
            <Box sx={{ display: { xs: "block", sm: "none", width: "100%" } }} />

            <BaseFormLabel label="寸法(長さ)">
              <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
                <Controller
                  name="depth"
                  control={control}
                  render={({ field, fieldState }) => (
                    <BaseNumberField
                      {...field}
                      size="small"
                      unit="cm"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                      sx={{ width: { xs: "100px", sm: "auto" } }}
                    />
                  )}
                />
              </Box>
            </BaseFormLabel>
            <BaseFormLabel label="寸法(幅)">
              <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
                <Controller
                  name="width"
                  control={control}
                  render={({ field, fieldState }) => (
                    <BaseNumberField
                      {...field}
                      size="small"
                      unit="cm"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                      sx={{ width: { xs: "100px", sm: "auto" } }}
                    />
                  )}
                />
              </Box>
            </BaseFormLabel>
            <BaseFormLabel label="寸法(高さ)">
              <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
                <Controller
                  name="height"
                  control={control}
                  render={({ field, fieldState }) => (
                    <BaseNumberField
                      {...field}
                      size="small"
                      unit="cm"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                      sx={{ width: { xs: "100px", sm: "auto" } }}
                    />
                  )}
                />
              </Box>
            </BaseFormLabel>
          </Box>
        )}
      </AccordionDetails>
    </BaseAccordion>
  );
};
